module.exports = __webpack_public_path__ + "img/IN.6a367aa2.svg";